module.exports = __webpack_public_path__ + "img/strollers-finish.514f90ed.jpg";